module.exports = __webpack_public_path__ + "img/web-app.21c0d5fe.png";